import React from 'react'
const UserContext = React.createContext({name:'',email:'',picture:'',isAuthorized:true,setIsAuthorized: null})
export const UserProvider = UserContext.Provider
export default UserContext